module.exports = __webpack_public_path__ + "img/one_6.92c1d12d.png";